window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gtag-event]').forEach((element) => {
    element.addEventListener('click', () => {
      const label = element.dataset.gtagEvent;
      window.trackEvent(label);
    });
  });
});

window.trackEvent = (label) => {
  console.log('trackEvent', label);

  if (typeof gtag === 'function') {
    // Standard gtag event call (Universal Analytics style)
    gtag('event', 'click', {
      event_category: 'button',
      event_label: label
    });
  } else {
    console.warn('gtag is not available');
  }
};